import { COMPONENT_IDS } from "@inter-ikea-storagetwo/range/dist/storage2ComponentIDs";
class MountingRailComponent {
    constructor() {
        this.doStoreInSnapshot = true;
        this.typeId = MountingRailComponent.id;
        this.serializable = false;
    }
    eq(_other) {
        return false;
    }
}
MountingRailComponent.id = COMPONENT_IDS.MOUNTING_RAIL_COMPONENT;
export default MountingRailComponent;
